const mutations = {
    setJobsList(state, data) {
        state.jobs = data;
    },
    resetJob(state) {
        state.job = {
            description: '',
        }
    },
    setJob(state, data) {
        state.job = data;
    }
}

export default mutations;